export default {
    request: {
        headers: {
            title: 'Портфель заявок',
            request_information: 'Основная информация',
            workConditions: 'Условия работы',
            hr_manager: 'HR-менеджер',
            basicInformation: 'Основная информация',
            requirementsForCandidate: 'Требования к кандидату',
            position: 'Позиция',
            status: 'Состояние',
            responsibleName: 'HR-менеджер',
            quantity: 'Количество',
            timePassed: 'Отправлена',
            date: 'Дата отправки'
        },
        add: 'Отправить заявку',
        company: 'Компания',
        organization: 'Компания',
        department: 'Отдел',
        position: 'Позиция',
        town: 'Город',
        quantity: 'Количество',
        reason: 'Причина возникновения',
        replacing: 'Замещаемый сотрудник',
        deadline: 'Закрыть до',
        salary: 'Оклад Мин-макс',
        bonuses: 'Бонусы и социальный пакет',
        probation: 'Исп. срок, дн.',
        requirements: 'Требования к опыту',
        age: {
            title: 'Возраст',
            value: 'лет'
        },
        experience: 'Стаж',
        education: 'Образование',
        educationComment: 'Комментарий к образованию',
        responsibilities: 'Обязанности',
        personalQualities: 'Личные качества',
        from: 'от',
        up_to: 'до',
        gross: 'До вычета налогов',
        net: 'После вычета налогов',
        workplace: 'Место работы',
        schedule: 'График работы',
        workType: 'Тип занятости',
        budget: 'Наличие в бюджете',
        result: 'Результат',
        responsible: 'ФИО',
        sex: 'Пол',
        comment: 'Дополнительная информация',
        status: 'Состояние',
        legal: 'Юридическое лицо',
        legalRoute: 'Найти сотрудника',
        legalRoutes: {
            current: 'Существующая должность',
            new: 'Новая должность',
        },
        legalCell: 'Ячейка штатного расписания',
        legalExplanation: 'Обоснование',
        legalCellOptions: 'Свойства ячейки штатного расписания',
        cellsMode: 'По названию ячейки ',
        employeesMode: 'По ФИО сотрудника',
        legalCellGrade: 'Грейд',
        legalCellNumrates: 'Свободно ставок',
        legalDepartment: 'Узел оргструктуры',
        legalRole: 'Роль в оргструктуре',
        legalChief: 'За кого подаёт заявку',
        legalRoleChief: 'Руководитель',
        legalRoleReplace: 'Подаёт заявки за руководителя',
        legalError: 'Вы не можете отправлять заявки, так как не привязаны к узлу оргструктуры в Experium. <br /> Обратитесь к сотрудникам отдела HR, так как только они имеют право привязывать сотрудников к узлам оргструктуры.',
    },
};
